import api from './client'


export const authApi = {
  getOrganizations: () => api.get('/organizations'),
  login: (Authorization) => api.get('/token', { headers: { Authorization } })
}
